import addError from '../../../utils/error.jsx';

export function request(data) {
    return {
        type: 'ROLE_CREATE_REQUEST',
        data
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'ROLE_CREATE_ERROR',
        errors
    };
}

export function finish(data) {
    return dispatch => {
        dispatch({
            type: 'ROLE_GET_REQUEST',
            id: data.id
        });

        return {
            type: 'ROLE_CREATE_FINISH',
            data
        };
    };
}
